import Sections from "./sections.service";

const sectionsModule = angular
  .module("app.services.sections", [])
  .service("Sections", Sections);

export default sectionsModule;



// WEBPACK FOOTER //
// ./src/services/sections/sections.module.js